<template>
   <div>
      <top-header></top-header>
      <main-menu></main-menu>
      <!-- Start the code for this screen here -->
      <div class="pagecontainer container">
         <div id="column1">
            <div class=" marginzero heading" ><span><b>Search Quote</b></span></div>
            <div class="card">
               <div class="frm-group">
                  <div class="col-10">
                     <label for="source">Quote Number</label>
                  </div>
                  <div class="col-10">
                     <input type="text" onkeypress="return ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 8 || !event.charCode == 32
                     || (event.charCode >= 48 && event.charCode <= 57));">
                  </div>
                  <div class="col-10">
                     <label for="source">Year </label>
                  </div>
                  <div class="col-10">
                     <input type="text" v-model.number="year"
                     maxlength="4"
                     onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))">
                  </div>
               </div>
               <div class="frm-group">
                  <div class="col-10">
                     <label for="source">Salesperson Name</label>
                  </div>
                  <div class="col-10">
                     <select  name="saleagent" data-vv-as="Sales Agent" v-model.trim="selectedEmployeeId" v-validate="'required_if:source,Dealer'" >
          <option  disabled value=""> Select Salesperson </option>
             <option v-for="(option,index) in agentList" v-bind:value="option.employeeId" v-bind:key="index"> {{ option.firstName }}</option>
        </select>
                  </div>
                  <div class="col-10">
                     <label for="source">Make </label>
                  </div>
                  <div class="col-10">
                     <input type="text" onkeypress="return ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) ||
                     || (event.charCode >= 48 && event.charCode <= 57));">
                  </div>
               </div>
               <div class="frm-group">
                  <div class="col-10">
                     <label for="source">Dealer Name</label>
                  </div>
                  <div class="col-10">
                  <select  name="dealerName" v-model="selectedDealerId">
          <option disabled value=""> Select a Dealer </option>
             <option v-for="(option,index) in dealersList" v-bind:value="option.dealerId" v-bind:key="index"> {{ option.dealerName }} </option>
        </select>

                  </div>
                  <div class="col-10">
                     <label for="source">Model </label>
                  </div>
                  <div class="col-10">
                     <input type="text" onkeypress="return ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) ||
                     || (event.charCode >= 48 && event.charCode <= 57));">
                  </div>
               </div>
               <div class="frm-group">
                  <div class="col-10">
                     <label for="source">Leesee Name</label>
                  </div>
                  <div class="col-10">
                     <multiselect
    style="width:100%"
    name="proposedLessee"
     v-validate="'required'"
    v-model="selectedCustomerId"
    :options="customersList"
    :value="customersList.customerId"
    :custom-label="displayFullName"
    selected="selected"
    id="customersdd">
    </multiselect>
                  </div>
                  <div class="col-10">
                     <label for="source">Quote Date From </label>
                  </div>
                  <div class="col-10">
                     <input type="Date">
                  </div>
                  <label>To</label>
                  <div class="col-10">
                  <input type="Date">
                  </div>
               </div>
               <br>
               <div>
                  <center>
                     <button id="customerbutton"  >Search</button>
                     <button id="customerbutton"  >Clear</button>

                  </center>
               </div>
            </div>
         </div>
         <div id="column1">
            <div class=" marginzero heading"  ><span><b>Quotes</b></span></div>
            <div class="card">
               <table  class="table-month-table">
                  <tr class="table-month-row">
                     <th v-for="(col,index) in colheaders" :key="index" class="table-month-header-blue"><span >{{col.header}}</span></th>
                  </tr>
                  <tr v-for="data in quotejson">
                     <td class="table-month-td"><input type="submit" value="Edit" id="customerbutton" @click="editdata(data.lmQuoteId)"></td>
                     <td class="table-month-td">{{data.lmQuote}}</td>
                      <td class="table-month-td">{{data.lmLeaseType}}</td>
                       <td class="table-month-td">{{data.lmQuoteId}}</td>
                        <td class="table-month-td">{{data.lmProposedLesseeName}}</td>
                         <td class="table-month-td">{{data.lmSalesAgent}}</td>
                          <td class="table-month-td">{{data.lmDealerName}}</td>
                           <td class="table-month-td"></td>
                            <td class="table-month-td"></td>
                             <td class="table-month-td">{{data.lmLoanAmount}}</td>
                              <td class="table-month-td">{{data.zipCode}}</td>
                               <td class="table-month-td"></td>

                  </tr>
               </table>
            </div>
         </div>
      </div>
      <!-- End of the code for this screen here -->
      <bottom-footer></bottom-footer>
   </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import Multiselect from 'vue-multiselect'
import httpemployee from '../js/http-employee.js'
import httpdeals from '../js/http-dealstracking.js'
import httpcustomer from '../js/http-customer.js'
import httpsource from '../js/http-managesource.js'
import quotejsonobject from '../json/quote.json'
import { bus } from '../main'
export default {
  props: ['quoteobject'],
  components: { MainMenu,
    TopHeader,
    BottomFooter
  },
  data () {
    return {
      quotejson: quotejsonobject,
      agentList: [],
      dealersList: [],
      customersList: [],
      selectedDealerId: '',
      selectedEmployeeId: '',
      selectedCustomerId: '',
      year: '',
      colheaders: [
        { header: 'Action' },
        { header: 'Date' },
        { header: 'Type' },
        { header: 'Quote#' },
        { header: 'Lessee' },
        { header: 'Agent' },
        { header: 'Dealer' },
        { header: 'Vehicle' },
        { header: 'Year' },
        { header: 'Amount' },
        { header: 'ZipState' },
        { header: 'QuoteCompletion' }
      ]
    }
  },
  methods: {
    fetchdata () {
      this.retrieveCustomerList()
      this.retrieveAgentList()
      this.retrieveDealerList()
    },
    retrieveCustomerList () {
      httpdeals.get('/quote/quotecustomers').then(response => {
        this.customersList = response.data
        // console.log(JSON.stringify(this.customersList))
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    displayFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName}`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },

    retrieveDealerList () {
      httpdeals.get('/quote/quotedealers').then(response => {
        this.dealersList = response.data
      })
        .catch(e => {
          console.log(e)
          this.errorlist.push(e)
        })
    },
    retrieveAgentList () {
      let searchEmployee = this.createSearchObject()
      httpdeals.get('/quote/quotesalesagents').then(response => {
        this.agentList = response.data
      })
        .catch(e => {
          this.errorslist.push(e)
        })
    },

    editdata (value) {
      this.$store.state.lmQuoteId = value
      bus.$emit('lmQuoteId', value)

      this.$router.push('/quoteGeneration')
    },

    createSearchObject () {
      return {
        'firstName': '',
        'lastName': '',
        'roleType': '',
        'statusCode': 'A'
      }
    }
  },
  computed: {
    customerType: function () {
      var custSelect = this.quoteobject.quote.customer_id.customerId
      var custType = ''
      if (this.quoteobject.quote.customer_id.customerId != '') {
        this.customersList.forEach(customerObj => {
          if (customerObj.customerId == custSelect) {
            custType = customerObj.customerType
          }
        })
      }
      return custType
    }
  },
  mounted () {
    this.fetchdata()
  }
}
</script>
<style scoped>
   .frm-group {
   /** display: -webkit-flex;  **/
   display: flex;
   flex-flow: row;
   align-items: left;
   width:100%;
   }
   .frm-group label {
   text-align: left;
   font-size: 12px;
   vertical-align: bottom;
   margin: 8px 15px 0px 10px;
   display:block;
   font-family: Verdana, Geneva, Tahoma, sans-serif;
   }
   .frm-group input {
   width: 100%;
   white-space: nowrap;
   border: 1px solid #ddd;
   border-radius: 5px;
   resize: vertical;
   font-size:12px;
   margin: 5px 10px 0px 0px;
   }
   .frm-group input[type="Date"]{
    padding: 6px
}
   #column1 {
   float: left;
   width: 100%;
   padding: 1px;
   }
   .frm-group select {
   width: 100%;
   border: 1px solid #ddd;
   border-radius: 5px;
   resize: vertical;
   margin: 5px 10px 0px 0px;
   }
</style>
